import React from 'react'
import { useTranslation } from 'react-i18next'
import { Box, Grid, Typography } from '@material-ui/core'
import BreadcrumbsComponent from 'src/components/BreadcrumbsComponent/BreadcrumbsComponent'
import {
  PROJECTS_LIST,
  METHODOLOGY_USED_LIST,
  TECHNOLOGIES_USED_LIST
} from './ProjectsContent.data'
import { useGlobalStyles } from 'src/mui/styles/globalStyles'
import { useStyles } from './ProjectsContent.styles'

const ProjectsContent = () => {
  const { t } = useTranslation()
  const classesGlobal = useGlobalStyles()
  const classes = useStyles()

  return (
    <>
      <Box className={classesGlobal.containerPages}>
        <BreadcrumbsComponent
          crumbs={[
            { label: t('navbar.start'), path: '/' },
            { label: t('projects.title') }
          ]}
        />
        <Typography variant="h3" className={classesGlobal.titleSection}>
          {t('projects.research-projects')}
        </Typography>
        <Grid container spacing={3} className={classes.projectsListContainer}>
          {PROJECTS_LIST.map((line, index) => (
            <Grid
              item
              className={classes.gridItem}
              key={index}
              sm={6}
              lg={3}
              xxl={3}
            >
              <img src={line.src} alt={line.text} className={classes.icon} />
              <Box
                style={{ alignSelf: 'flex-start' }}
                className={classes.iconText}
              >
                <Typography variant="body2">{line.category}</Typography>
                <Typography variant="body1" className={classes.gridItemText}>
                  {t(line.text)}
                </Typography>
              </Box>
            </Grid>
          ))}
        </Grid>
        <Typography className={classesGlobal.titleSection}>
          {t('projects.project-management')}
        </Typography>
        <Typography variant="body1" className={classes.methodology}>
          {t('projects.methodology')}
        </Typography>
        <Box className={classes.containerGridSuperior}>
          <Grid
            container
            direction="column"
            spacing={3}
            className={classes.gridContainer}
          >
            {METHODOLOGY_USED_LIST.map((line, index) => (
              <Grid item className={classes.gridItem} key={index}>
                <img src={line.src} alt={line.text} className={classes.icon} />
                <Typography variant="body1" className={classes.iconText}>
                  {t(line.text)}
                </Typography>
              </Grid>
            ))}
          </Grid>
          <Grid
            container
            className={`${classes.gridContainer} ${classes.gridContainerTechnologies}`}
            spacing={3}
          >
            {TECHNOLOGIES_USED_LIST.map((line, index) => (
              <Grid
                item
                className={classes.gridItem}
                key={index}
                xs={12}
                sm={6}
              >
                <Box className={classes.iconBackground}>
                  <img
                    src={line.src}
                    alt={line.text}
                    className={classes.icon}
                  />
                </Box>
                <Typography
                  variant="body1"
                  className={classes.technologiesTextIcon}
                >
                  {t(line.text)}
                </Typography>
              </Grid>
            ))}
          </Grid>
        </Box>
      </Box>
    </>
  )
}

export default ProjectsContent
